import { render, staticRenderFns } from "./returnMoneyRecord.vue?vue&type=template&id=14906351&scoped=true"
import script from "./returnMoneyRecord.vue?vue&type=script&lang=js"
export * from "./returnMoneyRecord.vue?vue&type=script&lang=js"
import style0 from "./returnMoneyRecord.vue?vue&type=style&index=0&id=14906351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14906351",
  null
  
)

export default component.exports